import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "../../common/ui/globalColors";
import { constants } from "../../common/constants/constants";

const BuildingSearchOptionCardStyled = styled.div`
  .building-search-option {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: baseline;
    gap: 8px;
    color: ${props => props.theme.text};

    .link {
      color: ${props => props.theme.text};
      opacity: 0.4;
      
      .value-type {
        color: ${colors.textColors.black};
      }
    }
    
    .type {
      padding-inline-end: 10px;
    }
  }
`;

/**
 * @param building
 * @returns {JSX.Element}
 * @constructor
 */
export const BuildingSearchOptionCard = ({ building }) => {
    const { t } = useTranslation();
    if (!building?.externalID || !building?.Title) return null;

    const buildingId = building.externalID;
    const buildingTitle = building.Title;
    const url = `/${constants.pages.addCollectionStatus}-new/${buildingId}`;

    return (
        <BuildingSearchOptionCardStyled>
            <div className='building-search-option bllink-text-tiny'>
                <a className='link'
                   href={url}>
                    <span className='type'>
                        {t('reports.collection_report')}
                    </span>
                    <span className='type value-type'>{buildingTitle}</span>
                </a>
            </div>
        </BuildingSearchOptionCardStyled>
    );
};
